import { Component, Input } from "@angular/core";
import { StatusPageComponent } from "../common/status-page/status-page.component";

/** Placeholder page for a section that isn't built yet (Support, Settings). */
@Component({
  selector: "app-coming-soon",
  standalone: true,
  imports: [StatusPageComponent],
  templateUrl: "./coming-soon.component.html",
  styleUrl: "./coming-soon.component.scss"
})
export class ComingSoonComponent {
  @Input() header!: string;

  get title(): string {
    return `${this.header || "This section"} is on its way`;
  }
}
